








































































import { Vue, Component } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import { settingStorageApi } from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import * as worker_threads from "worker_threads";
import { settingStorageLocalApi } from "@/getinfo-api/settingsStorage";

@Component({
  components: { TextField, CustomButton, CField, CBlock }
})
export default class CompanyConfiguration extends Vue {
  domainMail!: { mail: string; count: number };
  mail: string = "";
  isEdit: boolean = false;
  isLoading: boolean = false;
  workHrs!: number;
  dayOffs: number[] = [];
  isNeedFinishLearning: boolean = false;
  data() {
    return {
      domainMail: undefined,
      workHrs: undefined
    };
  }

  get company() {
    return getCurrentCompanyId();
  }

  get weekDays() {
    return [
      { value: 1, label: this.$t(this.$translate.Monday) },
      { value: 2, label: this.$t(this.$translate.Tuesday) },
      { value: 3, label: this.$t(this.$translate.Wednesday) },
      { value: 4, label: this.$t(this.$translate.Thursday) },
      { value: 5, label: this.$t(this.$translate.Friday) },
      { value: 6, label: this.$t(this.$translate.Saturday) },
      { value: 0, label: this.$t(this.$translate.Sunday) }
    ];
  }

  cancel() {
    this.domainMail.mail = this.mail;
    this.dayOffs = this.$store.state.companyUtils.companyDayOffs;
    this.workHrs = this.$store.state.companyUtils.companyAmountWorkHrs;
    this.isNeedFinishLearning = this.$store.state.companyUtils.isFinishLearningWithEndLr;
    this.isEdit = false;
  }

  saveDomain() {
    this.isLoading = true;
    settingStorageApi.Company.putCompanySettings(this.company, [
      {
        name: "domainMail",
        value: this.domainMail
      }
    ])
      .then(() => {
        this.isEdit = false;
        this.mail = this.domainMail.mail;
        this.$bvToast.toast(
          `${this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)}`,
          {
            variant: "success",
            title: `${this.$tc(this.$translate.Success)}`
          }
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
    settingStorageApi.Company.putCompanySettings(this.company, [
      {
        name: "companySettings",
        value: {
          companyAmountWorkHrs: this.workHrs,
          companyDayOffs: this.dayOffs
        }
      }
    ])
      .then(() => {
        this.isEdit = false;
        this.$store.state.companyUtils.companyDayOffs = this.dayOffs;
        this.$store.state.companyUtils.companyAmountWorkHrs = this.workHrs;
        this.$bvToast.toast(
          `${this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)}`,
          {
            variant: "success",
            title: `${this.$tc(this.$translate.Success)}`
          }
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
    settingStorageLocalApi.Company.setIsFinishLearningWithEndLr(
      this.company,
      this.isNeedFinishLearning
    ).then(res => {
      this.$store.commit(
        "companyUtils/changeIsFinishLearningWithEndLr",
        res.isFinish
      );
    });
  }

  created() {
    if (this.company) {
      settingStorageApi.Company.getCompanySettings(this.company, [
        "domainMail"
      ]).then((res: { data: any }) => {
        if (res.data.length === 0) {
          this.domainMail = { mail: "", count: 10000 };
        } else {
          this.domainMail = res.data[0].value;
          this.mail = res.data[0].value.mail;
        }
      });

      settingStorageApi.Company.getCompanySettings(this.company, [
        "companySettings"
      ]).then((res: { data: any }) => {
        if (res.data.length === 0) {
          this.dayOffs = this.$store.state.companyUtils.companyDayOffs;
          this.workHrs = this.$store.state.companyUtils.companyAmountWorkHrs;
        } else {
          this.dayOffs = res.data[0].value.companyDayOffs;
          this.workHrs = res.data[0].value.companyAmountWorkHrs;
          this.$store.state.companyUtils.companyDayOffs =
            res.data[0].value.companyDayOffs;
          this.$store.state.companyUtils.companyAmountWorkHrs =
            res.data[0].value.companyAmountWorkHrs;
        }
      });
    }
    this.isNeedFinishLearning = this.$store.state.companyUtils.isFinishLearningWithEndLr;
  }
}
